import React from "react";

import { ToolbarButton } from "components/base";

export interface FilterConfig {
  icon: React.ReactNode;
  tooltip: string;
  testId: string;
}

export const BaseMidstreamFilterButton: React.FC<{
  config: FilterConfig;
  isActive: boolean;
  isDisabled: boolean;
  disabledReason?: string;
  onToggle: () => void;
}> = ({ config, isActive, isDisabled, disabledReason, onToggle }) => {
  return (
    <ToolbarButton
      active={isActive}
      disabled={isDisabled}
      icon={config.icon}
      onToggle={onToggle}
      tooltipText={config.tooltip}
      testId={config.testId}
      styleKey="mapToolbar"
      btnDisabledReason={disabledReason}
    />
  );
};
